import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

// import { delay } from '@holmescorp/common';
import { childmap, createNlsMiddleware, keymap, lccstate, userstate } from '@holmescorp/lcc-state';
import { ParentTree } from '@holmescorp/lcc-interfaces';

import { ProgressViz } from './progress-viz';
import css from '../css/progress-viz.m.css';

const nls = createNlsMiddleware('ditabook');
const factory = create({ lccstate, userstate, nls, theme });

export const AssessProgressViz = factory(({ middleware: { lccstate, userstate, nls, theme } }) => {
	const {
		messages: {
			assess_progress_threshold_low_label = '[ditabook] assess_progress_threshold_low_label',
			assess_progress_threshold_mid_label = '[ditabook] assess_progress_threshold_mid_label',
			assess_progress_threshold_high_label = '[ditabook] assess_progress_threshold_high_label',
			assess_progress_threshold_low = '60',
			assess_progress_threshold_high = '80',
			assess_topic_label = 'TOPIC',
			assess_section_label = 'SECTION',
			assess_summary = '[ditabook] assess_summary'
		}
	} = nls();
	const themeCss = theme.classes(css);

	const { get, path } = userstate;
	const assessment: ParentTree = get(path('assessment'));
	const roots: string[] = lccstate.get(lccstate.path('ditaroots'));

	const getStatus = (percent: number) => {
		const score = percent * 100;
		if (score === 0 || score < parseFloat(assess_progress_threshold_low)) {
			return {
				label: assess_progress_threshold_low_label,
				icon: 'fas fa-exclamation-triangle',
				iconClass: themeCss.inexperienced,
				labelClass: themeCss.inexperiencedLabel
			};
		}
		if (score < parseFloat(assess_progress_threshold_high)) {
			return {
				label: assess_progress_threshold_mid_label,
				icon: 'fas fa-chevron-circle-up',
				iconClass: themeCss.improvement,
				labelClass: themeCss.improvementLabel
			};
		}
		return {
			label: assess_progress_threshold_high_label,
			icon: 'fas fa-check-circle',
			iconClass: themeCss.proficient,
			labelClass: themeCss.proficientLabel
		};
	};

	const topicResults = (root: string) => {
		const tsets = childmap.get(root) || [];

		return tsets.map((ts) => {
			const percentBase: number = assessment[ts].data.percent;
			const percent: number = percentBase > 1.0 ? percentBase / 100.0 : percentBase;
			const title: string = keymap.get(ts)!.title;
			const xqa = `topicset-viz ${ts}`;
			return w(ProgressViz, { xqa, title, percent });
		});
	};

	const kids = roots.map((root) => {
		const percentBase = assessment[root].data.percent;
		const percent = percentBase > 1.0 ? percentBase / 100.0 : percentBase;
		const title = keymap.get(root)?.title || root;
		const status = getStatus(percent);

		return v('div', { classes: [themeCss.domain, 'vizDomain'] }, [
			v('div', { classes: themeCss.topicHeader }, [
				v('div', { classes: themeCss.header }, [
					v('div', { classes: themeCss.topic }, [assess_topic_label.toUpperCase()]),
					v('div', { classes: [themeCss.topicTitle] }, [title]),
					v('div', { classes: [themeCss.topicStatus] }, [
						v('span', { classes: [themeCss.statusLabel, status.labelClass] }, [status.label]),
						v('i', { classes: [status.icon, status.iconClass] })
					])
				]),
				v('div', { classes: themeCss.summary }, [v('span', {}, [assess_summary])])
			]),
			v('div', { classes: themeCss.topicSection }, [
				v('div', { classes: themeCss.section }, [assess_section_label.toUpperCase()]),
				v('div', { classes: themeCss.sections }, [...topicResults(root)])
			])
		]);
	});

	return v('div', { key: 'root', xqa: `viz` }, [
		v('div', { key: `scores`, role: 'list', xqa: `viz pre-test`, classes: [themeCss.root] }, kids)
	]);
});
